module.exports = __webpack_public_path__ + "img/favicon.9328884c.png";